import React from "react";

const Tab3: React.FC = () => {
    return (
        <>
            <h1>Tab3</h1>
        </>
    );
};

export default Tab3;
